// Vendor
import { ElementRef, EventEmitter, SimpleChanges } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';
// Utils / Constants
import { ABSOLUTE_ATTRIBUTION_PERIODICITY_OPTIONS } from 'SecuritiesApp/ts/constants/attribution.constants';
import { getContributorsDetractorsColorGradient } from 'SecuritiesApp/ts/utils/attribution-utils';
import { isPeriodicityDisabled } from 'SecuritiesApp/ts/features/attribution-relative/utils';
import { formatDateString } from 'Core/redesign/utils/date';
// Interfaces
import { PerformancePeriodicity, } from 'SecuritiesApp/ts/interfaces/attribution.interface';
// Services
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "SecuritiesApp/ts/services/securities.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i8 from "../../../module-upsell/module-upsell.component";
const _c0 = a0 => ({ "text-gray-60": a0 });
const _c1 = () => [];
function AttributionAbsoluteChartComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li")(2, "a", 19);
    i0.ɵɵlistener("click", function AttributionAbsoluteChartComponent_ng_container_10_Template_a_click_2_listener() { const periodicityOption_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.updatePeriodicity(periodicityOption_r4.value)); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const periodicityOption_r4 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("chart-control-item ", periodicityOption_r4.value === ctx_r4.performancePeriodicity ? "current" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", periodicityOption_r4.disabled)("ngClass", i0.ɵɵpureFunction1(6, _c0, periodicityOption_r4.disabled));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(periodicityOption_r4.label);
} }
function AttributionAbsoluteChartComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelement(1, "ycn-loading-symbol", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("loaderMessage", "Loading Contributor/Detractor Info...");
} }
function AttributionAbsoluteChartComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r4.errorMessage, " ");
} }
function AttributionAbsoluteChartComponent_div_14_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("As of ", ctx_r4.leastLatestDate, "");
} }
function AttributionAbsoluteChartComponent_div_14_div_7_ng_container_2_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 33)(1, "div", 34)(2, "span", 35);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 17);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 36)(7, "div", 37)(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const i_r6 = i0.ɵɵnextContext().index;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("stock ", ctx_r4.contributors[i_r6].color, " col-3");
    i0.ɵɵpropertyInterpolate("href", ctx_r4.contributors[i_r6].url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.contributors[i_r6].display_security_id);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("+", ctx_r4.contributors[i_r6].contribution_points_fmtd, "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r4.contributors[i_r6].change);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("\u00A0(", ctx_r4.contributors[i_r6].change_percent, "%)");
} }
function AttributionAbsoluteChartComponent_div_14_div_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AttributionAbsoluteChartComponent_div_14_div_7_ng_container_2_a_1_Template, 12, 8, "a", 32);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r6 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext(3);
    const emptyCell_r7 = i0.ɵɵreference(17);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.contributors[i_r6])("ngIfElse", emptyCell_r7);
} }
function AttributionAbsoluteChartComponent_div_14_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30)(1, "div", 31);
    i0.ɵɵtemplate(2, AttributionAbsoluteChartComponent_div_14_div_7_ng_container_2_Template, 2, 2, "ng-container", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c1).constructor(8));
} }
function AttributionAbsoluteChartComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 24)(2, "div", 25);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(3, "svg", 26);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5, "Top Contributors");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, AttributionAbsoluteChartComponent_div_14_div_6_Template, 2, 1, "div", 27);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, AttributionAbsoluteChartComponent_div_14_div_7_Template, 3, 2, "div", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const noData_r8 = i0.ɵɵreference(19);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-pulling-up-index");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.leastLatestDate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.contributors.length > 0)("ngIfElse", noData_r8);
} }
function AttributionAbsoluteChartComponent_div_15_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("As of ", ctx_r4.leastLatestDate, "");
} }
function AttributionAbsoluteChartComponent_div_15_div_7_ng_container_2_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 33)(1, "div", 34)(2, "span", 35);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 17);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 36)(7, "div", 37)(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const i_r9 = i0.ɵɵnextContext().index;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("stock ", ctx_r4.detractors[i_r9].color, " col-3");
    i0.ɵɵpropertyInterpolate("href", ctx_r4.detractors[i_r9].url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.detractors[i_r9].display_security_id);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.detractors[i_r9].contribution_points_fmtd);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r4.detractors[i_r9].change);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("\u00A0(", ctx_r4.detractors[i_r9].change_percent, "%)");
} }
function AttributionAbsoluteChartComponent_div_15_div_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AttributionAbsoluteChartComponent_div_15_div_7_ng_container_2_a_1_Template, 12, 8, "a", 32);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r9 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext(3);
    const emptyCell_r7 = i0.ɵɵreference(17);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.detractors[i_r9])("ngIfElse", emptyCell_r7);
} }
function AttributionAbsoluteChartComponent_div_15_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30)(1, "div", 31);
    i0.ɵɵtemplate(2, AttributionAbsoluteChartComponent_div_15_div_7_ng_container_2_Template, 2, 2, "ng-container", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c1).constructor(8));
} }
function AttributionAbsoluteChartComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 24)(2, "div", 25);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(3, "svg", 38);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5, "Top Detractors");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, AttributionAbsoluteChartComponent_div_15_div_6_Template, 2, 1, "div", 27);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, AttributionAbsoluteChartComponent_div_15_div_7_Template, 3, 2, "div", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const noData_r8 = i0.ɵɵreference(19);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-pulling-down-index");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.leastLatestDate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.detractors.length > 0)("ngIfElse", noData_r8);
} }
function AttributionAbsoluteChartComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39)(1, "div", 34)(2, "span", 35);
    i0.ɵɵtext(3, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 36)(5, "div", 37)(6, "span");
    i0.ɵɵtext(7, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9, "\u00A0");
    i0.ɵɵelementEnd()()()();
} }
function AttributionAbsoluteChartComponent_ng_template_18_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39)(1, "div", 34)(2, "span", 35);
    i0.ɵɵtext(3, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 36)(5, "div", 37)(6, "span");
    i0.ɵɵtext(7, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9, "\u00A0");
    i0.ɵɵelementEnd()()()();
} }
function AttributionAbsoluteChartComponent_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30)(1, "div", 31);
    i0.ɵɵtemplate(2, AttributionAbsoluteChartComponent_ng_template_18_div_2_Template, 10, 0, "div", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 41);
    i0.ɵɵtext(4, "No Data Available");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c1).constructor(8));
} }
export class AttributionAbsoluteChartComponent {
    constructor(eltRef, accountsService, securitiesService) {
        this.eltRef = eltRef;
        this.accountsService = accountsService;
        this.securitiesService = securitiesService;
        this.performancePeriodicityChange = new EventEmitter();
        this.fetchSubscription$ = null;
        this.contributors = [];
        this.detractors = [];
        this.errorMessage = '';
        this.leastLatestDate = '';
        this.loading = true;
        this.periodicityOptions = cloneDeep(ABSOLUTE_ATTRIBUTION_PERIODICITY_OPTIONS);
    }
    ngOnInit() {
        this.fetchSubscription$ = this.fetchAttributionData();
    }
    ngOnChanges(changes) {
        if (changes.asOfDate?.currentValue) {
            this.periodicityOptions.forEach((periodicity) => {
                // eslint-disable-next-line no-param-reassign
                periodicity.disabled = isPeriodicityDisabled(periodicity.value, changes.asOfDate.currentValue);
            });
        }
    }
    ngOnDestroy() {
        if (this.fetchSubscription$ !== null)
            this.fetchSubscription$.unsubscribe();
    }
    updatePeriodicity(performancePeriodicity) {
        const periodicityChanged = this.performancePeriodicity !== performancePeriodicity;
        if (periodicityChanged) {
            this.performancePeriodicity = performancePeriodicity;
            this.fetchAttributionData();
            const preferenceName = `${this.securityType}_attribution_absolute_tab_zoom`;
            this.performancePeriodicityChange.emit(performancePeriodicity);
            this.accountsService.putUserPreferences({ [preferenceName]: performancePeriodicity }).subscribe();
        }
    }
    fetchAttributionData() {
        if (this.fetchSubscription$ !== null)
            this.fetchSubscription$.unsubscribe();
        this.loading = true;
        return this.securitiesService
            .getContributorAndDetractorInfo(this.securityId, this.performancePeriodicity, this.holdingsLayer, this.asOfDate, this.asOfDateCustom ? formatDateString(this.asOfDateCustom) : '')
            .subscribe({
            next: (response) => {
                this.leastLatestDate = response.least_latest_date;
                this.contributors = getContributorsDetractorsColorGradient(response.contributors, true);
                this.detractors = getContributorsDetractorsColorGradient(response.detractors, false);
            },
            error: (error) => {
                this.contributors = [];
                this.detractors = [];
                this.errorMessage = error.error.error_message;
                this.loading = false;
            },
            complete: () => {
                this.loading = false;
            },
        });
    }
}
AttributionAbsoluteChartComponent.ɵfac = function AttributionAbsoluteChartComponent_Factory(t) { return new (t || AttributionAbsoluteChartComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i2.SecuritiesService)); };
AttributionAbsoluteChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AttributionAbsoluteChartComponent, selectors: [["ycn-attribution-absolute-chart"]], inputs: { performancePeriodicity: "performancePeriodicity", securityId: "securityId", securityType: "securityType", asOfDateCustom: "asOfDateCustom", asOfDate: "asOfDate", holdingsLayer: "holdingsLayer" }, outputs: { performancePeriodicityChange: "performancePeriodicityChange" }, features: [i0.ɵɵNgOnChangesFeature], decls: 27, vars: 6, consts: [["emptyCell", ""], ["noData", ""], ["contributorsDetractorsHelpModal", ""], [1, "panel", "panel-data", "panel-stocks"], [1, "panel-header"], [1, "panel-title"], [1, "help-toggler", 3, "click"], [1, "panel-content"], [3, "title"], [1, "mb-1"], [1, "chart-control", "chart-control-compact", "border-0"], [4, "ngFor", "ngForOf"], [1, "divider-horizontal"], ["class", "stocks d-flex justify-content-center align-items-center", "style", "height: 400px;", 4, "ngIf"], ["class", "feedback feedback-invalid", 4, "ngIf"], ["class", "stocks", 4, "ngIf"], [1, "stocks-footer", "panel-date", "mb-1"], [1, "stock-label"], [1, "text-gray-50"], ["href", "javascript:void(0)", "ycnDisabled", "", 1, "chart-control-link", 3, "click", "disabled", "ngClass"], [1, "stocks", "d-flex", "justify-content-center", "align-items-center", 2, "height", "400px"], [3, "loaderMessage"], [1, "feedback", "feedback-invalid"], [1, "stocks"], [1, "stocks-header"], [1, "stocks-title"], ["ycnIcon", "", 1, "text-green", 3, "name"], ["class", "panel-date", 4, "ngIf"], ["class", "stocks-body", 4, "ngIf", "ngIfElse"], [1, "panel-date"], [1, "stocks-body"], [1, "row", "no-gutters"], ["target", "_blank", 3, "class", "href", 4, "ngIf", "ngIfElse"], ["target", "_blank", 3, "href"], [1, "stock-header"], [1, "stock-title"], [1, "stock-content"], [1, "stock-value"], ["ycnIcon", "", 1, "text-red", 3, "name"], [1, "stock", "bg-neutral", "col-3"], ["class", "stock bg-neutral col-3", 4, "ngFor", "ngForOf"], [1, "panel-data-empty-message"]], template: function AttributionAbsoluteChartComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "h3", 5);
        i0.ɵɵtext(3, "Attribution\u00A0 ");
        i0.ɵɵelementStart(4, "span", 6);
        i0.ɵɵlistener("click", function AttributionAbsoluteChartComponent_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r1); const contributorsDetractorsHelpModal_r2 = i0.ɵɵreference(26); return i0.ɵɵresetView(contributorsDetractorsHelpModal_r2.openModal("attribution_contributors_detractors")); });
        i0.ɵɵtext(5, " (?)");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(6, "div", 7);
        i0.ɵɵelement(7, "ycn-module-upsell", 8);
        i0.ɵɵelementStart(8, "div", 9)(9, "ul", 10);
        i0.ɵɵtemplate(10, AttributionAbsoluteChartComponent_ng_container_10_Template, 4, 8, "ng-container", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(11, "div", 12);
        i0.ɵɵtemplate(12, AttributionAbsoluteChartComponent_div_12_Template, 2, 1, "div", 13)(13, AttributionAbsoluteChartComponent_div_13_Template, 2, 1, "div", 14)(14, AttributionAbsoluteChartComponent_div_14_Template, 8, 4, "div", 15)(15, AttributionAbsoluteChartComponent_div_15_Template, 8, 4, "div", 15)(16, AttributionAbsoluteChartComponent_ng_template_16_Template, 10, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(18, AttributionAbsoluteChartComponent_ng_template_18_Template, 5, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 16)(21, "div", 17);
        i0.ɵɵtext(22, "#");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "span", 18);
        i0.ɵɵtext(24, "Points contributed to the overall return are estimates");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(25, "ycn-help-modal", null, 2);
    } if (rf & 2) {
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("title", "Attribution");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.periodicityOptions);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.errorMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i4.DisabledDirective, i5.HelpModalComponent, i6.IconDirective, i7.LoadingSymbolComponent, i8.ModuleUpsellComponent], encapsulation: 2 });
